<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <mat-chip-grid #itemChipList>
    <mat-chip-row
      *ngFor="let item of selectedItems"
      [removable]="removable"
      (removed)="removeElement(selectedItemsControl, item)"
    >
      {{ item }}
      <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
    </mat-chip-row>
    <input
      #itemInput
      [formControl]="itemInputControl"
      [matAutocomplete]="itemAutocomplete"
      [matChipInputFor]="itemChipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="addElement(selectedItemsControl, itemInput, itemInputControl)"
    />
  </mat-chip-grid>
  <mat-autocomplete
    #itemAutocomplete="matAutocomplete"
    (optionSelected)="addOptionElement(selectedItemsControl, itemInput, itemInputControl)"
  >
    <mat-option *ngFor="let items of filteredItems" [value]="items">
      {{ items }}
    </mat-option>
  </mat-autocomplete>
  <ui-svg-icon
    *ngIf="isIconVisible && selectedItemsControl?.value?.length < 2"
    [name]="iconNameList.ListView"
    matSuffix
  ></ui-svg-icon>
</mat-form-field>
